import { createTranslationResources } from '@dec/shared/utils/languages';

import az from './az/translation.json';
import de from './de/translation.json';
import en from './en/translation.json';
import es from './es/translation.json';
import fr from './fr/translation.json';
import pt from './pt/translation.json';

export const translationResources = createTranslationResources({ en, es, fr, de, pt, az });

export type TranslationResource = typeof en;
